export const SurgeryData = [
    {
        id: 1,
        image: "/Images/Child/Pediatrics/Surgery/Herniorrhaphy.webp",
        title: "Herniorrhaphy",
        subTitle:"A procedure to push protruding tissue back into the abdomen and close the opening with stitches"
    },
    {
        id: 2,
        image: "/Images/Child/Pediatrics/Surgery/Appendectomy.webp",
        title: "Appendicectomy",
        subTitle:"A surgical procedure to remove a child's appendix.",
    },
    {
        id: 3,
        image: "/Images/Child/Pediatrics/Surgery/Circumcision.webp",
        title: "Circumcision",
        subTitle:"A surgical procedure that removes the foreskin of a child's penis.",
    },
    {
        id: 4,
        image: "/Images/Child/Pediatrics/Surgery/Tonsillectomy.webp",
        title: "Tonsillectomy",
        subTitle:"A surgical procedure to remove a child's tonsils.",
    },
    {
        id: 5,
        image: "/Images/Child/Pediatrics/Surgery/Skin grafting.webp",
        title: "Skin grafting",
        subTitle:"A surgical procedure that transfers healthy skin from one part of a child's body to another to treat damaged skin.",
    },  
    {
        id: 6,
        image: "/Images/Child/Pediatrics/Surgery/Hand Surgery.webp",
        title: "Hand Surgery",
        subTitle:"A surgical procedure that treats hand injuries and congenital hand differences in children.",
    }, 
];

